import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSnackbar } from '../../hooks/useAppSnackbar';
import { useAppSelector } from '../../store';
import { selectIdentity } from '../../store/entities/identity';
import { setErrorSnacks } from '../../utils/error';
import { hasRole } from '../../utils/roles';
import { QcsTypography } from '../common/basic/QcsTypography';
import { TourniquetDialog } from './TourniquetDialog';
import { TourniquetInvitationContainer } from './TourniquetInvitationContainer';
import { InvitationDto } from '@api/models/invitation/InvitationDto';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';
import { UserRole } from '@api/models/enums/UserRole';
import { TrainingRunButton } from '../trainingRun/TrainingRunButton';
import { invitationPersonService } from '@api/services/services';

interface Props {
  invitation: InvitationDto;
  invitationPerson: InvitedPersonDto;
}

export const TourniquetInvitationTrainings: FC<Props> = ({ invitation, invitationPerson }) => {
  const { t } = useTranslation();
  const identity = useAppSelector(selectIdentity);
  const { enqueueErrorSnackbar } = useAppSnackbar();
  const [sending, setSending] = useState(false);
  const [sentModalIsVisible, setSentModalIsVisible] = useState(false);

  const m3 = t('tourniquet.issueTrainings3')?.split('{0}');

  const handleSend = async () => {
    setSending(true);
    try {
      await invitationPersonService.resendNotification(invitation.id!, invitationPerson.id!);
      setSentModalIsVisible(true);
    } catch (err) {
      setErrorSnacks(err, enqueueErrorSnackbar);
    }
    setSending(false);
  };

  const handleModalClose = () => {
    setSentModalIsVisible(false);
  };

  if (hasRole(identity.roles, [UserRole.TourniquetTraining, UserRole.Training])) {
    return (
      <>
        <TourniquetDialog mode={sentModalIsVisible ? 'EMAIL' : undefined} onClose={handleModalClose} />

        <TourniquetInvitationContainer icon="error">
          <QcsTypography>{t('tourniquet.issueTrainings1')}</QcsTypography>
        </TourniquetInvitationContainer>

        {invitationPerson.requiredTrainings && invitationPerson.requiredTrainings.length > 0 && (
          <TrainingRunButton workers={invitationPerson}>{t('tourniquet.runTraining')}</TrainingRunButton>
        )}

        {invitationPerson.email && (
          <TourniquetInvitationContainer icon="tip" buttonNameT="tourniquet.sendLink" buttonLoading={sending} onButtonClick={handleSend}>
            <QcsTypography>
              {t('tourniquet.issueTrainings2')} {m3?.[0]}
              <strong>{invitationPerson.email}</strong>
              {m3?.[1]}
            </QcsTypography>
            <QcsTypography>{t('tourniquet.issueTrainings4')}</QcsTypography>
          </TourniquetInvitationContainer>
        )}
      </>
    );
  }

  return (
    <>
      <TourniquetDialog mode={sentModalIsVisible ? 'EMAIL' : undefined} onClose={handleModalClose} />
      <TourniquetInvitationContainer icon="error">
        <QcsTypography>{t('tourniquet.issueTrainings1')}</QcsTypography>
      </TourniquetInvitationContainer>

      {invitationPerson.email && (
        <TourniquetInvitationContainer icon="tip" buttonNameT="tourniquet.sendLink" buttonLoading={sending} onButtonClick={handleSend}>
          <QcsTypography>
            {t('tourniquet.issueTrainings2')} {m3?.[0]}
            <strong>{invitationPerson.email}</strong>
            {m3?.[1]}
          </QcsTypography>
          <QcsTypography>{t('tourniquet.issueTrainings4')}</QcsTypography>
        </TourniquetInvitationContainer>
      )}
    </>
  );
};
